import { useState } from "react";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, InputAdornment, Table,
    TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ExcludedEwes from "./ExcludedEwes.js";

export default function MatingEwesSummary({ selectedCodes = [], results }) {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const filtered = selectedCodes.filter((code) => String(code).includes(query.trim()));
    return <Box sx={{ mt: 2, display: "flex", flexWrap: "wrap", gap: 2, width: "100%" }}>
        <TextField id="selected-ewes-count" label="Επιλεγμένες προβατίνες" value={selectedCodes.length} variant="standard"
            sx={{ flex: "1 1 240px" }} InputProps={{ readOnly: true, endAdornment: <InputAdornment position="end">
                <Tooltip title="Δείτε όλες τις επιλεγμένες προβατίνες"><span>
                    <IconButton aria-label="Προβολή επιλεγμένων προβατίνων" disabled={!selectedCodes.length}
                        onClick={() => { setQuery(""); setOpen(true); }} sx={{ width: 44, height: 44 }}><VisibilityIcon /></IconButton>
                </span></Tooltip>
            </InputAdornment> }} />
        <ExcludedEwes results={results} />
        <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" aria-labelledby="selected-ewes-title">
            <DialogTitle id="selected-ewes-title">Επιλεγμένες προβατίνες ({selectedCodes.length})</DialogTitle>
            <DialogContent>
                <TextField label="Αναζήτηση κωδικού γενεαλογικού βιβλίου" type="search" fullWidth size="small"
                    value={query} onChange={(event) => setQuery(event.target.value)} sx={{ mt: 1, mb: 1 }} />
                <Typography variant="body2" sx={{ mb: 1 }}>Εμφανίζονται {filtered.length} από {selectedCodes.length} προβατίνες.</Typography>
                <TableContainer sx={{ maxHeight: "55vh" }}>
                    <Table stickyHeader size="small" aria-label="Επιλεγμένες προβατίνες">
                        <TableHead><TableRow><TableCell>Κωδικός Γενεαλογικού Βιβλίου</TableCell></TableRow></TableHead>
                        <TableBody>{filtered.map((code) => <TableRow key={code}><TableCell>{code}</TableCell></TableRow>)}
                            {!filtered.length && <TableRow><TableCell>Δεν βρέθηκαν προβατίνες με αυτόν τον κωδικό.</TableCell></TableRow>}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
            <DialogActions><Button onClick={() => setOpen(false)}>Κλείσιμο</Button></DialogActions>
        </Dialog>
    </Box>;
}
